/**
 * JSON Schema for the main object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/MediaList",
  type: "object",
  properties: {
    origin: { type: "string" },
    scope: {
      type: "string",
      enum: ["shallow", "deep"]
    },
    pageSize: { type: "number" },
    page: { type: "number" },
    listName: {
      type: "string",
      enum: ["mystarzlist", "watchlist", "historylist"]
    },
    titleIds: {
      anyOf: [
        {
          type: "array",
          items: {
            type: "string"
          },
          minItems: 1
        },
        {
          type: "string"
        }
      ]
    },
    seriesDetailLevel: {
      type: "string",
      enum: ["series", "episode"]
    }
  }
};
